// extracted by css-extract-rspack-plugin
export default {"nonMobileWrapper":"_8f3ae762","isMobileWrapper":"_4d3d4717"};